import { render, staticRenderFns } from "./AlertIndex.vue?vue&type=template&id=8815b94a&scoped=true&"
import script from "./AlertIndex.vue?vue&type=script&lang=js&"
export * from "./AlertIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8815b94a",
  null
  
)

export default component.exports